
import { ref } from "vue";
import JigsawQuestion from "@/components/JigsawQuestion";

export default {
  name: "Test",
  components: { JigsawQuestion },
  setup() {
    const question = ref({
      id: 1,
      type: 14,
      question_params: {
        row_num: 2,
        col_num: 3,
        aspect_ratio_length: 1,
        aspect_ratio_width: 1,
        images: [
          {
            id: "1",
            url: "https://devppublic.jilingshu.com.cn/exam_center/teacher/89/20220314/-rc-upload-1647239863215-4.jpg",
            is_fake: false,
          },
          // {
          //   id: "2",
          //   url: "https://devppublic.jilingshu.com.cn/exam_center/teacher/89/20220314/-rc-upload-1647239863215-4.jpg",
          //   is_fake: false,
          // },
        ],
        image_items: [
          {
            image_id: "1",
            row: 1,
            col: 1,
          },
          {
            image_id: "1",
            row: 1,
            col: 2,
          },
          {
            image_id: "1",
            row: 1,
            col: 3,
          },
          {
            image_id: "1",
            row: 2,
            col: 1,
          },
          {
            image_id: "1",
            row: 2,
            col: 2,
          },
          {
            image_id: "1",
            row: 2,
            col: 3,
          },
        ],
      },
      answer_params: {
        items: [
          {
            image_id: "1",
            image_row: 1,
            image_col: 1,
            box_row: 2,
            box_col: 3,
          },
          // {
          //   image_id: "1",
          //   row: 1,
          //   col: 2,
          // },
        ],
      },
    });
    return {
      question,
    };
  },
};
